const ITEMS = ["VENDOR EVENTS", "SCHOOL EVENTS", "BIRTHDAY PARTIES", "THE FAMOUS NACHO BOX"];

const Sequence = ({ hidden = false }) => (
  <div aria-hidden={hidden || undefined} className="flex w-max shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`font-display whitespace-nowrap px-6 py-3 text-2xl font-bold uppercase tracking-wide sm:text-3xl lg:text-4xl ${
            i % 2 === 0 ? "text-ink" : "text-outline"
          }`}
        >
          {item}
        </span>
        <span className="text-2xl text-tomato sm:text-3xl">✦</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="events-marquee"
      className="marquee-paused relative z-10 -my-3 -rotate-1 scale-[1.02] overflow-hidden border-y-4 border-ink bg-sunburst py-2 shadow-pop"
    >
      <div className="animate-marquee flex w-max">
        <Sequence />
        <Sequence hidden />
      </div>
    </div>
  );
}
